import { Loader } from '@googlemaps/js-api-loader'

let loader = undefined

export default async function loadGoogleMaps(libraries = []) {
  loader = loader || new Loader({ apiKey: PetRescue.env.google.mapsAPI })

  return loader.load(libraries)
}
